/* Common Imports */

import React from "react";

/* Redux Imports */

import StateInterface from "../../../../../redux-magic/state-interface";

/* Component Imports */

import { Fab, styled, Tooltip, useTheme } from "@mui/material";
import ShareModal from "../../../../modals/ShareModal";
// import FeedBackModal from "../../../../modals/FeedbackModal";

/* Icon Imports */

import { KeyboardArrowUp, Share } from "@mui/icons-material";
import { CreateNewSharesThunk } from "../../../../../redux-magic/store";

/* Styled Components */

const Container = styled("div")(({ theme }) => ({
	display: "flex",
	flexDirection: "column",
	justifyContent: "flex-end",
	alignItems: "flex-start",
	position: "fixed",
	bottom: theme.spacing(11),
	right: theme.spacing(2),
	zIndex: 5,
	[theme.breakpoints.down("md")]: {
		bottom: theme.spacing(17),
	},
}));

const CustomFab = styled(Fab)(({ theme }) => ({
	background: theme.palette.primary.main,
	color: theme.palette.primary.contrastText,
	boxShadow: "none",
	"&:hover": {
		background: "#CA6614",
	},
}));

const Fabs = ({
	session,
	propertyData,
	dispatch,
	profile_context,
}: {
	session: any;
	propertyData: StateInterface["single_property_page"];
	dispatch: Function;
	profile_context: StateInterface["profile_context"];
}) => {
	const theme = useTheme();

	const [visible, setVisible] = React.useState(false);
	const [shareModal, setShareModal] = React.useState(false);
	const [isMobileOrTablet, setIsMobileOrTablet] = React.useState<boolean>(false);
	React.useEffect(() => {
		if (window.innerWidth < 960) {
			setIsMobileOrTablet(true);
		}
	}, []);

	const toggleVisible = () => {
		const scrolled = document.documentElement.scrollTop;
		if (scrolled > 300) {
			setVisible(true);
		} else if (scrolled <= 300) {
			setVisible(false);
		}
	};

	const isBrowser = typeof window !== `undefined`;

	if (isBrowser) {
		window.addEventListener("scroll", toggleVisible);
	}

	const handleClickTop = () => {
		const isBrowser = typeof window !== `undefined`;
		if (isBrowser) {
			scrollTo(0, 0);
		}
		// document.body.scrollTop = 0; /* For Safari */
		// document.documentElement.scrollTop = 0; /* For Chrome, Firefox, IE and Opera */
	};

	/* Share Modal */

	const handleOnClick = () => {
		if (navigator.share) {
			navigator
				.share({
					title: `Check out this property`,
					text: "Have a look at this property on Beegru",
					url: process.env.PRODUCTION_URL + "properties/" + propertyData.property.slug,
				})
				.then(() => {
					console.log("Thanks for sharing!");
						dispatch(
							CreateNewSharesThunk({
								entity_type: "property",
								entity_id: propertyData.property._id,
								shared_through: "mobile",
								entity_created_by: propertyData.property.created_by,
								is_guest: session ? false : true,
								logged_user:
									session && profile_context
										? {
												user_id: profile_context ? profile_context.user_id : "",
												business_profile_id: profile_context ? profile_context.business_profile_id : "",
												is_business_profile: profile_context ? profile_context.is_business_profile : false,
											}
										: null,
							}),
						);
				})
				.catch(console.error);
		}
	};

	const handleShareModalOpen = () => {
		setShareModal(true);
	};

	const handleShareModalClose = () => {
		setShareModal(false);
	};

	/* Feedback Modal */

	// const [FeedbackModal, setFeedbackModal] = React.useState(false);

	// const handleFeedbackModalOpen = () => {
	//   setFeedbackModal(true);
	// };

	// const handleFeedbackModalClose = (event: any, reason: any) => {
	//   if (reason !== "backdropClick") {
	//     setFeedbackModal(false);
	//   }
	// };

	// const [screenshot, setScreenshot] = React.useState<any>();

	// const [screenshotBuffer, setScreenshotBuffer] = React.useState<any>();

	// const capture = async () => {
	//   const video = document.createElement("video");
	//   try {
	//     // asking for permission
	//     const stream = await navigator.mediaDevices.getDisplayMedia({
	//       //@ts-ignore
	//       preferCurrentTab: true,
	//     });

	//     video.addEventListener("loadedmetadata", () => {
	//       const canvas = document.createElement("canvas");

	//       const context: CanvasRenderingContext2D | null =
	//         canvas.getContext("2d") || null;
	//       //passing the video width and height to the canvas
	//       canvas.width = video.videoWidth;
	//       canvas.height = video.videoHeight;
	//       video.play();
	//       // drawing an image form the captured video stream
	//       (context as CanvasRenderingContext2D).drawImage(
	//         video,
	//         0,
	//         0,
	//         canvas.width,
	//         canvas.height
	//       );
	//       stream.getVideoTracks()[0].stop();
	//       setScreenshot(canvas.toDataURL("image/png"));
	//       try {
	//         canvas.toBlob(async (blob: Blob) => {
	//           setScreenshotBuffer(await blob.arrayBuffer());
	//         });
	//       } catch (err) {
	//         console.error("Error: " + err);
	//       }
	//     });
	//     video.srcObject = stream;
	//   } catch (err) {
	//     console.error("Error: " + err);
	//     setFeedbackModal(false);
	//   }
	// };

	return (
		<Container>
			{/* Feedback modal */}

			{/* <FeedBackModal
        session={session}
        dispatch={dispatch}
        open={FeedbackModal}
        handleClose={handleFeedbackModalClose}
        screenshotURL={screenshot}
        screenshotBuffer={screenshotBuffer}
      /> */}

			{/* Share Modal */}

			<ShareModal
				open={shareModal}
				handleClose={handleShareModalClose}
				url={process.env.PRODUCTION_URL + "properties/" + propertyData.property.slug}
				session={session}
				dispatch={dispatch}
				entity="property"
				creator_user_id={propertyData.property.created_by.user_id}
				entity_created_by={propertyData.property.created_by}
				entity_id={propertyData.property._id}
				profile_context={profile_context}
			/>

			{/* Go to top */}

			<Tooltip
				title="Scroll To Top"
				placement="left"
			>
				<CustomFab
					size="small"
					sx={{ display: visible ? "inline" : "none" }}
					aria-label="Go to top"
					onClick={handleClickTop}
				>
					<KeyboardArrowUp
						fontSize="medium"
						sx={{ marginTop: "0.3rem" }}
					/>
				</CustomFab>
			</Tooltip>

			{/* Share  */}

			{propertyData.property && propertyData.property.published === true ? (
				<Tooltip
					title="Share"
					placement="left"
				>
					<CustomFab
						size="small"
						sx={{
							marginTop: "0.5rem",
							zIndex: 6,
						}}
						aria-label="Share"
						onClick={isMobileOrTablet ? handleOnClick : handleShareModalOpen}
					>
						<Share
							fontSize="medium"
							sx={{ padding: "0rem 0.1rem 0rem 0rem" }}
						/>
					</CustomFab>
				</Tooltip>
			) : null}

			{/* Call */}

			{/* <Link
				href={`tel:${propertyData.property.created_by}`}
				passHref
			>
				<Tooltip
					title="Call Now"
					placement="left"
				>
					<CustomFab
						size="small"
						sx={{ display: visible ? "inline" : "none" }}
						aria-label="Go to top"
						onClick={handleClickTop}
					>
						<Phone
							fontSize="small"
							sx={{ marginTop: "0.3rem" }}
						/>
					</CustomFab>
				</Tooltip>
			</Link> */}

			{/* Feedback */}

			{/* <Tooltip title="Report a Bug!" placement="left">
        <CustomFab
          size="small"
          sx={{ marginTop: "0.5rem", zIndex: 6 }}
          aria-label="Feedback"
          onClick={() => {
            capture();
          }}
          onTouchEnd={() => {
            handleFeedbackModalOpen();
          }}
        >
          <BugReport
            fontSize="medium"
            sx={{ padding: "0rem 0.1rem 0rem 0rem" }}
          />
        </CustomFab>
      </Tooltip> */}
		</Container>
	);
};
export default Fabs;
